import { UserSettings } from '@miq/utils';

export const MY_FORMATS = UserSettings.getGlobalDateDisplayFormat('value');
export const NA = 'N/A';
export const UTC_EDP_INPUT_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';
